export default __webpack_public_path__ + "static/media/Pisces.d6893837.svg";